import { memo } from 'react';
import { FontBold, Font } from './FontBold';
import { Container } from '../container/Container';

interface Props {
    title?: string;
    subTitle?: string;
    isUpperCase?: boolean;
    color?: string;
    fontSize?: number;
}

const FontBoldComponent = ({ fontSize, color, subTitle, title, isUpperCase = false }: Props) => {

    return (
        <Container margin="8px 0px" >
            <FontBold color={color} fontSize={fontSize}>{title?.toLocaleUpperCase()}</FontBold>
            <Font fontSize={fontSize}>{!isUpperCase ? subTitle?.toLocaleUpperCase() : subTitle}</Font>
        </Container>
    )
}

export default memo(FontBoldComponent);
